// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   LinkedIn-Style Bottom-Right Docked Live Chat Widget - Client Portal
   ========================================================================== */

.li-chat-container {
    position: fixed;
    bottom: 20px;
    right: 24px;
    z-index: 99999;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

/* ==========================================================================
   1. Floating Chat Icon Button on Bottom Right
   ========================================================================== */
.client-floating-chat-trigger {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    flex-direction: row-reverse;
}

.client-chat-icon-btn {
    position: relative;
    width: 58px;
    height: 58px;
    border-radius: 50%;
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4), 0 8px 30px rgba(0, 0, 0, 0.15);
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.client-floating-chat-trigger:hover .client-chat-icon-btn {
    transform: scale(1.08) translateY(-2px);
    box-shadow: 0 8px 24px rgba(37, 99, 235, 0.5), 0 12px 35px rgba(0, 0, 0, 0.2);
}

.client-chat-icon-main {
    font-size: 26px;
    line-height: 1;
}

.client-chat-pulse-ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid rgba(37, 99, 235, 0.6);
    animation: clientPulse 2.2s infinite;
    pointer-events: none;
}

@keyframes clientPulse {
    0% {
        transform: scale(0.95);
        opacity: 0.8;
    }

    70% {
        transform: scale(1.35);
        opacity: 0;
    }

    100% {
        transform: scale(1.35);
        opacity: 0;
    }
}

.client-chat-badge-bubble {
    position: absolute;
    top: -2px;
    right: -2px;
    background: #ef4444;
    color: #ffffff;
    font-size: 11px;
    font-weight: 800;
    min-width: 21px;
    height: 21px;
    border-radius: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 6px rgba(239, 68, 68, 0.5);
    animation: liPulse 1.8s infinite;
}

.client-chat-pill-tooltip {
    background: #ffffff;
    color: #0f172a;
    font-size: 13px;
    font-weight: 700;
    padding: 8px 14px;
    border-radius: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
    border: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    gap: 7px;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.tooltip-online-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #10b981;
}

.client-floating-chat-trigger:hover .client-chat-pill-tooltip {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.16);
    transform: translateX(-3px);
}


.li-avatar-wrap {
    position: relative;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
}

.li-avatar-img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
}

.li-avatar-fallback {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
}

.li-online-dot {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 9px;
    height: 9px;
    background: #10b981;
    border: 2px solid #ffffff;
    border-radius: 50%;
}

.li-docked-title {
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.01em;
}

.li-docked-right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.li-unread-badge {
    background: #ef4444;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    min-width: 19px;
    height: 19px;
    padding: 0 5px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.4);
    animation: liPulse 2s infinite;
}

@keyframes liPulse {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.08);
    }
}

.li-chevron-icon {
    font-size: 14px;
    color: #64748b;
    transition: transform 0.2s ease;
}

/* ==========================================================================
   2. Open Floating Chat Window
   ========================================================================== */
.li-chat-window {
    width: 340px;
    height: 540px;
    max-height: calc(100vh - 40px);
    max-width: calc(100vw - 32px);
    background: #ffffff;
    border: 1px solid #cbd5e1;
    border-radius: 14px;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.22);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: liSlideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes liSlideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Header */
.li-chat-header {
    height: 62px;
    padding: 0 18px;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
}

.li-header-info {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
}

.li-header-names {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.li-header-title {
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.25;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.li-header-status {
    font-size: 12px;
    color: #10b981;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 1px;
}

.li-header-actions {
    display: flex;
    align-items: center;
    gap: 6px;
}

.li-btn-header-action {
    background: transparent;
    border: none;
    color: #64748b;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.li-btn-header-action:hover {
    background: #f1f5f9;
    color: #0f172a;
}

/* Message Thread Body */
.li-chat-body {
    flex: 1 1;
    padding: 16px 18px;
    overflow-y: auto;
    background: #f8fafc;
    display: flex;
    flex-direction: column;
    gap: 14px;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}

.li-chat-body::-webkit-scrollbar {
    width: 6px;
}

.li-chat-body::-webkit-scrollbar-track {
    background: transparent;
}

.li-chat-body::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 6px;
}

.li-chat-body::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}

/* Welcome banner */
.li-welcome-box {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px 16px;
    text-align: center;
    margin-bottom: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

/* text-align: center;
    margin-bottom: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
} */

.li-welcome-icon {
    font-size: 24px;
    margin-bottom: 4px;
}

.li-welcome-title {
    font-size: 13px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 3px;
}

.li-welcome-text {
    font-size: 11.5px;
    color: #64748b;
    line-height: 1.4;
    margin: 0;
}

/* Date divider */
.li-date-divider {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 6px 0;
}

.li-date-divider span {
    background: #e2e8f0;
    color: #64748b;
    font-size: 10.5px;
    font-weight: 600;
    padding: 2px 10px;
    border-radius: 10px;
}

/* Message Row */
.li-msg-row {
    display: flex;
    gap: 8px;
    max-width: 86%;
}

.li-msg-row.received {
    align-self: flex-start;
}

.li-msg-row.sent {
    align-self: flex-end;
    flex-direction: row-reverse;
}

.li-msg-avatar {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
    margin-top: 2px;
}

.li-msg-avatar-fallback {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: #3b82f6;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
}

.li-msg-content-wrap {
    display: flex;
    flex-direction: column;
}

.li-msg-row.sent .li-msg-content-wrap {
    align-items: flex-end;
}

.li-msg-sender-name {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    margin-bottom: 3px;
}

.li-msg-bubble {
    padding: 11px 16px;
    border-radius: 16px;
    font-size: 14.5px;
    line-height: 1.5;
    word-break: break-word;
    position: relative;
}

.li-msg-row.received .li-msg-bubble {
    background: #ffffff;
    color: #1e293b;
    border: 1px solid #e2e8f0;
    border-top-left-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.li-msg-row.sent .li-msg-bubble {
    background: #2563eb;
    color: #ffffff;
    border-top-right-radius: 4px;
    box-shadow: 0 2px 6px rgba(37, 99, 235, 0.3);
}

.li-msg-meta {
    font-size: 11px;
    color: #94a3b8;
    margin-top: 4px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.li-msg-row.sent .li-msg-meta {
    color: #64748b;
}

/* Attachments inside bubble */
.li-msg-attachments {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 6px;
}

.li-attachment-img {
    max-width: 180px;
    max-height: 140px;
    border-radius: 8px;
    object-fit: cover;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.li-attachment-file {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 6px;
    text-decoration: none;
    font-size: 11.5px;
    font-weight: 600;
    background: rgba(0, 0, 0, 0.05);
    color: inherit;
    transition: background 0.15s ease;
}

.li-msg-row.sent .li-attachment-file {
    background: rgba(255, 255, 255, 0.2);
    color: #ffffff;
}

.li-attachment-file:hover {
    background: rgba(0, 0, 0, 0.1);
}

.li-msg-row.sent .li-attachment-file:hover {
    background: rgba(255, 255, 255, 0.3);
}

/* Typing Indicator Animation */
.li-typing-row {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: flex-start;
}

.li-typing-bubble {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    padding: 8px 14px;
    border-radius: 14px;
    border-top-left-radius: 3px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.li-dot {
    width: 6px;
    height: 6px;
    background: #94a3b8;
    border-radius: 50%;
    animation: liDotBounce 1.4s infinite ease-in-out both;
}

.li-dot:nth-child(1) {
    animation-delay: -0.32s;
}

.li-dot:nth-child(2) {
    animation-delay: -0.16s;
}

@keyframes liDotBounce {

    0%,
    80%,
    100% {
        transform: scale(0);
    }

    40% {
        transform: scale(1);
    }
}

/* ==========================================================================
   3. Chat Input Footer
   ========================================================================== */
.li-chat-footer {
    background: #ffffff;
    border-top: 1px solid #e2e8f0;
    padding: 12px 16px;
    flex-shrink: 0;
}

/* Selected attachment pill */
.li-selected-attach-pill {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 6px 10px;
    font-size: 12px;
    color: #334155;
    margin-bottom: 10px;
}

.li-attach-info {
    display: flex;
    align-items: center;
    gap: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.li-btn-remove-attach {
    background: transparent;
    border: none;
    color: #dc2626;
    cursor: pointer;
    padding: 0 4px;
    font-size: 14px;
}

.li-input-row {
    display: flex;
    align-items: flex-end;
    gap: 10px;
}

.li-chat-textarea {
    flex: 1 1;
    border: 1px solid #cbd5e1;
    border-radius: 20px;
    padding: 10px 16px;
    font-size: 14px;
    color: #1e293b;
    resize: none;
    outline: none;
    max-height: 100px;
    min-height: 42px;
    line-height: 1.45;
    transition: border-color 0.15s ease;
}

.li-chat-textarea:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
}

.li-chat-textarea::placeholder {
    color: #94a3b8;
}

.li-btn-attach {
    background: transparent;
    border: none;
    color: #64748b;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;
}

.li-btn-attach:hover {
    background: #f1f5f9;
    color: #2563eb;
}

.li-btn-send {
    background: #2563eb;
    border: none;
    color: #ffffff;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35);
}

.li-btn-send:hover:not(:disabled) {
    background: #1d4ed8;
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(37, 99, 235, 0.4);
}

.li-btn-send:disabled {
    background: #cbd5e1;
    cursor: not-allowed;
    box-shadow: none;
}

/* Mobile responsive */
@media (max-width: 576px) {
    .li-chat-container {
        right: 12px;
        left: 12px;
    }

    .li-chat-docked-bar {
        width: 100%;
    }

    .li-chat-window {
        width: 100%;
        height: 80vh;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/LinkedInChat/LinkedInChat.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,cAAc;IACd,gGAAgG;AACpG;;AAEA;;+EAE+E;AAC/E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6EAA6E;IAC7E,mDAAmD;AACvD;;AAEA;IACI,uCAAuC;IACvC,6EAA6E;AACjF;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,4CAA4C;IAC5C,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;AAC/B;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,4CAA4C;IAC5C,8BAA8B;AAClC;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,+BAA+B;AACnC;;AAEA;;+EAE+E;AAC/E;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,WAAW;AACX;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;;;GAGG;;AAEH;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,4BAA4B;IAC5B,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;IAC/B,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI;;;QAGI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;;+EAE+E;AAC/E;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":["/* ==========================================================================\n   LinkedIn-Style Bottom-Right Docked Live Chat Widget - Client Portal\n   ========================================================================== */\n\n.li-chat-container {\n    position: fixed;\n    bottom: 20px;\n    right: 24px;\n    z-index: 99999;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n/* ==========================================================================\n   1. Floating Chat Icon Button on Bottom Right\n   ========================================================================== */\n.client-floating-chat-trigger {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n    user-select: none;\n    flex-direction: row-reverse;\n}\n\n.client-chat-icon-btn {\n    position: relative;\n    width: 58px;\n    height: 58px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #2563eb, #1d4ed8);\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4), 0 8px 30px rgba(0, 0, 0, 0.15);\n    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.client-floating-chat-trigger:hover .client-chat-icon-btn {\n    transform: scale(1.08) translateY(-2px);\n    box-shadow: 0 8px 24px rgba(37, 99, 235, 0.5), 0 12px 35px rgba(0, 0, 0, 0.2);\n}\n\n.client-chat-icon-main {\n    font-size: 26px;\n    line-height: 1;\n}\n\n.client-chat-pulse-ring {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    border: 2px solid rgba(37, 99, 235, 0.6);\n    animation: clientPulse 2.2s infinite;\n    pointer-events: none;\n}\n\n@keyframes clientPulse {\n    0% {\n        transform: scale(0.95);\n        opacity: 0.8;\n    }\n\n    70% {\n        transform: scale(1.35);\n        opacity: 0;\n    }\n\n    100% {\n        transform: scale(1.35);\n        opacity: 0;\n    }\n}\n\n.client-chat-badge-bubble {\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    background: #ef4444;\n    color: #ffffff;\n    font-size: 11px;\n    font-weight: 800;\n    min-width: 21px;\n    height: 21px;\n    border-radius: 11px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 5px;\n    border: 2px solid #ffffff;\n    box-shadow: 0 2px 6px rgba(239, 68, 68, 0.5);\n    animation: liPulse 1.8s infinite;\n}\n\n.client-chat-pill-tooltip {\n    background: #ffffff;\n    color: #0f172a;\n    font-size: 13px;\n    font-weight: 700;\n    padding: 8px 14px;\n    border-radius: 20px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n    border: 1px solid #e2e8f0;\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.tooltip-online-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #10b981;\n}\n\n.client-floating-chat-trigger:hover .client-chat-pill-tooltip {\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.16);\n    transform: translateX(-3px);\n}\n\n\n.li-avatar-wrap {\n    position: relative;\n    width: 32px;\n    height: 32px;\n    flex-shrink: 0;\n}\n\n.li-avatar-img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.li-avatar-fallback {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #2563eb, #1d4ed8);\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n}\n\n.li-online-dot {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 9px;\n    height: 9px;\n    background: #10b981;\n    border: 2px solid #ffffff;\n    border-radius: 50%;\n}\n\n.li-docked-title {\n    font-size: 14px;\n    font-weight: 700;\n    color: #0f172a;\n    letter-spacing: -0.01em;\n}\n\n.li-docked-right {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.li-unread-badge {\n    background: #ef4444;\n    color: #ffffff;\n    font-size: 11px;\n    font-weight: 700;\n    min-width: 19px;\n    height: 19px;\n    padding: 0 5px;\n    border-radius: 10px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.4);\n    animation: liPulse 2s infinite;\n}\n\n@keyframes liPulse {\n\n    0%,\n    100% {\n        transform: scale(1);\n    }\n\n    50% {\n        transform: scale(1.08);\n    }\n}\n\n.li-chevron-icon {\n    font-size: 14px;\n    color: #64748b;\n    transition: transform 0.2s ease;\n}\n\n/* ==========================================================================\n   2. Open Floating Chat Window\n   ========================================================================== */\n.li-chat-window {\n    width: 340px;\n    height: 540px;\n    max-height: calc(100vh - 40px);\n    max-width: calc(100vw - 32px);\n    background: #ffffff;\n    border: 1px solid #cbd5e1;\n    border-radius: 14px;\n    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.22);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    animation: liSlideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes liSlideUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Header */\n.li-chat-header {\n    height: 62px;\n    padding: 0 18px;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-shrink: 0;\n}\n\n.li-header-info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-width: 0;\n}\n\n.li-header-names {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.li-header-title {\n    font-size: 15px;\n    font-weight: 700;\n    color: #0f172a;\n    line-height: 1.25;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.li-header-status {\n    font-size: 12px;\n    color: #10b981;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-top: 1px;\n}\n\n.li-header-actions {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.li-btn-header-action {\n    background: transparent;\n    border: none;\n    color: #64748b;\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.li-btn-header-action:hover {\n    background: #f1f5f9;\n    color: #0f172a;\n}\n\n/* Message Thread Body */\n.li-chat-body {\n    flex: 1;\n    padding: 16px 18px;\n    overflow-y: auto;\n    background: #f8fafc;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    scrollbar-width: thin;\n    scrollbar-color: #cbd5e1 transparent;\n}\n\n.li-chat-body::-webkit-scrollbar {\n    width: 6px;\n}\n\n.li-chat-body::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.li-chat-body::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 6px;\n}\n\n.li-chat-body::-webkit-scrollbar-thumb:hover {\n    background: #94a3b8;\n}\n\n/* Welcome banner */\n.li-welcome-box {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 14px 16px;\n    text-align: center;\n    margin-bottom: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n/* text-align: center;\n    margin-bottom: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n} */\n\n.li-welcome-icon {\n    font-size: 24px;\n    margin-bottom: 4px;\n}\n\n.li-welcome-title {\n    font-size: 13px;\n    font-weight: 700;\n    color: #0f172a;\n    margin-bottom: 3px;\n}\n\n.li-welcome-text {\n    font-size: 11.5px;\n    color: #64748b;\n    line-height: 1.4;\n    margin: 0;\n}\n\n/* Date divider */\n.li-date-divider {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 6px 0;\n}\n\n.li-date-divider span {\n    background: #e2e8f0;\n    color: #64748b;\n    font-size: 10.5px;\n    font-weight: 600;\n    padding: 2px 10px;\n    border-radius: 10px;\n}\n\n/* Message Row */\n.li-msg-row {\n    display: flex;\n    gap: 8px;\n    max-width: 86%;\n}\n\n.li-msg-row.received {\n    align-self: flex-start;\n}\n\n.li-msg-row.sent {\n    align-self: flex-end;\n    flex-direction: row-reverse;\n}\n\n.li-msg-avatar {\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    object-fit: cover;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.li-msg-avatar-fallback {\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    background: #3b82f6;\n    color: #ffffff;\n    font-size: 11px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.li-msg-content-wrap {\n    display: flex;\n    flex-direction: column;\n}\n\n.li-msg-row.sent .li-msg-content-wrap {\n    align-items: flex-end;\n}\n\n.li-msg-sender-name {\n    font-size: 12px;\n    font-weight: 600;\n    color: #64748b;\n    margin-bottom: 3px;\n}\n\n.li-msg-bubble {\n    padding: 11px 16px;\n    border-radius: 16px;\n    font-size: 14.5px;\n    line-height: 1.5;\n    word-break: break-word;\n    position: relative;\n}\n\n.li-msg-row.received .li-msg-bubble {\n    background: #ffffff;\n    color: #1e293b;\n    border: 1px solid #e2e8f0;\n    border-top-left-radius: 4px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.li-msg-row.sent .li-msg-bubble {\n    background: #2563eb;\n    color: #ffffff;\n    border-top-right-radius: 4px;\n    box-shadow: 0 2px 6px rgba(37, 99, 235, 0.3);\n}\n\n.li-msg-meta {\n    font-size: 11px;\n    color: #94a3b8;\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.li-msg-row.sent .li-msg-meta {\n    color: #64748b;\n}\n\n/* Attachments inside bubble */\n.li-msg-attachments {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-top: 6px;\n}\n\n.li-attachment-img {\n    max-width: 180px;\n    max-height: 140px;\n    border-radius: 8px;\n    object-fit: cover;\n    cursor: pointer;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.li-attachment-file {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 10px;\n    border-radius: 6px;\n    text-decoration: none;\n    font-size: 11.5px;\n    font-weight: 600;\n    background: rgba(0, 0, 0, 0.05);\n    color: inherit;\n    transition: background 0.15s ease;\n}\n\n.li-msg-row.sent .li-attachment-file {\n    background: rgba(255, 255, 255, 0.2);\n    color: #ffffff;\n}\n\n.li-attachment-file:hover {\n    background: rgba(0, 0, 0, 0.1);\n}\n\n.li-msg-row.sent .li-attachment-file:hover {\n    background: rgba(255, 255, 255, 0.3);\n}\n\n/* Typing Indicator Animation */\n.li-typing-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    align-self: flex-start;\n}\n\n.li-typing-bubble {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    padding: 8px 14px;\n    border-radius: 14px;\n    border-top-left-radius: 3px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.li-dot {\n    width: 6px;\n    height: 6px;\n    background: #94a3b8;\n    border-radius: 50%;\n    animation: liDotBounce 1.4s infinite ease-in-out both;\n}\n\n.li-dot:nth-child(1) {\n    animation-delay: -0.32s;\n}\n\n.li-dot:nth-child(2) {\n    animation-delay: -0.16s;\n}\n\n@keyframes liDotBounce {\n\n    0%,\n    80%,\n    100% {\n        transform: scale(0);\n    }\n\n    40% {\n        transform: scale(1);\n    }\n}\n\n/* ==========================================================================\n   3. Chat Input Footer\n   ========================================================================== */\n.li-chat-footer {\n    background: #ffffff;\n    border-top: 1px solid #e2e8f0;\n    padding: 12px 16px;\n    flex-shrink: 0;\n}\n\n/* Selected attachment pill */\n.li-selected-attach-pill {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #f1f5f9;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    padding: 6px 10px;\n    font-size: 12px;\n    color: #334155;\n    margin-bottom: 10px;\n}\n\n.li-attach-info {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.li-btn-remove-attach {\n    background: transparent;\n    border: none;\n    color: #dc2626;\n    cursor: pointer;\n    padding: 0 4px;\n    font-size: 14px;\n}\n\n.li-input-row {\n    display: flex;\n    align-items: flex-end;\n    gap: 10px;\n}\n\n.li-chat-textarea {\n    flex: 1;\n    border: 1px solid #cbd5e1;\n    border-radius: 20px;\n    padding: 10px 16px;\n    font-size: 14px;\n    color: #1e293b;\n    resize: none;\n    outline: none;\n    max-height: 100px;\n    min-height: 42px;\n    line-height: 1.45;\n    transition: border-color 0.15s ease;\n}\n\n.li-chat-textarea:focus {\n    border-color: #2563eb;\n    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);\n}\n\n.li-chat-textarea::placeholder {\n    color: #94a3b8;\n}\n\n.li-btn-attach {\n    background: transparent;\n    border: none;\n    color: #64748b;\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    flex-shrink: 0;\n}\n\n.li-btn-attach:hover {\n    background: #f1f5f9;\n    color: #2563eb;\n}\n\n.li-btn-send {\n    background: #2563eb;\n    border: none;\n    color: #ffffff;\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    flex-shrink: 0;\n    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35);\n}\n\n.li-btn-send:hover:not(:disabled) {\n    background: #1d4ed8;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 10px rgba(37, 99, 235, 0.4);\n}\n\n.li-btn-send:disabled {\n    background: #cbd5e1;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n/* Mobile responsive */\n@media (max-width: 576px) {\n    .li-chat-container {\n        right: 12px;\n        left: 12px;\n    }\n\n    .li-chat-docked-bar {\n        width: 100%;\n    }\n\n    .li-chat-window {\n        width: 100%;\n        height: 80vh;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
